import React from 'react';
import { Sun, Moon, Laptop } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';
import { cn } from '../../utils/cn';

export const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { theme, setTheme } = useTheme();

  return (
    <div className={cn('inline-flex items-center gap-1 p-1 bg-slate-100 dark:bg-[#0f1b2d] border border-slate-200 dark:border-slate-800 rounded-xl shadow-sm', className)}>
      <button
        onClick={() => setTheme('light')}
        className={cn(
          'p-1.5 rounded-lg text-xs transition-all',
          theme === 'light'
            ? 'bg-white text-[#4a82c2] shadow-sm font-bold'
            : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
        )}
        title="Light theme"
        aria-label="Switch to light theme"
      >
        <Sun size={15} />
      </button>
      <button
        onClick={() => setTheme('dark')}
        className={cn(
          'p-1.5 rounded-lg text-xs transition-all',
          theme === 'dark'
            ? 'bg-slate-800 text-sky-400 font-bold shadow-sm'
            : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
        )}
        title="Dark theme"
        aria-label="Switch to dark theme"
      >
        <Moon size={15} />
      </button>
      <button
        onClick={() => setTheme('system')}
        className={cn(
          'p-1.5 rounded-lg text-xs transition-all',
          theme === 'system'
            ? 'bg-white dark:bg-slate-800 text-[#4a82c2] dark:text-sky-400 font-bold shadow-sm'
            : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
        )}
        title="System theme"
        aria-label="Switch to system theme"
      >
        <Laptop size={15} />
      </button>
    </div>
  );
};
